export default __webpack_public_path__ + "static/media/bannerDesktop.8643f8ae.png";